import { render } from "./AgoraClient.vue?vue&type=template&id=e1553470"
import script from "./AgoraClient.vue?vue&type=script&lang=js"
export * from "./AgoraClient.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/share/application/sanar-provider-webapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__